import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ca8f361e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "icon-preview-wrapper" };
const _hoisted_2 = { class: "readonly-class-display" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "no-icon-text"
};
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminIconComponentVariableBuiltValue',
    props: {
        value: {}
    },
    emits: ["focus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isString = (value) => {
            return typeof value === "string";
        };
        const className = computed(() => {
            return isString(props.value) ? props.value : "";
        });
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "admin-icon-input-group admin-icon-built-value",
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('focus')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("i", {
                        class: _normalizeClass(className.value || 'far fa-question-circle icon-placeholder')
                    }, null, 2 /* CLASS */)
                ]),
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.value), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, "No Icon"))
                ])
            ]));
        };
    }
});
